import { GetterTree } from 'vuex';
import { ProductInterface } from '@/types/product';
import { ProductsState, RootState } from '@/types/state';

const getters: GetterTree<ProductsState, RootState> = {
  allProducts(state): ProductInterface[] {
    return state.products;
  },

  getByID(state): (arg0: number) => ProductInterface | undefined {
    return (productID: number) => state.products.find((prod) => prod.id === productID);
  },
};

export default getters;
